module.exports = __webpack_public_path__ + "img/apple.5467d7c3.svg";